import accurateInterval from 'accurate-interval'
import axios from '@/api/config.js'
import {
  submitTypingSingleAdvancedRecordAPI,
  submitTypingCombineAdvancedRecordAPI,
  checkIfPassTypingSingleAdvancedLesson,
  checkIfPassTypingCombineAdvancedLesson
} from '@/api/typingAPI'
import {
  firstPracticedAPI
} from '@/api/authAPI'

const TIMER_STEP = 1000

const state = {
  lesson: null,
  speed: null,
  numOfDrops: null,
  practiceMinutes: null,
  started: false,
  configured: false,
  mode: null,
  correctTimes: 0,
  incorrectTimes: 0, // 按錯次數
  missedTimes: 0, // 錯過的球數
  totalKeyHit: 0,
  missedBalls: [], // 錯過和打錯的球
  timer: null,
  timeElapsed: null,
  continuousCorrectTimes: 0, // 连续正确次数
  continuousInorrectTimes: 0, // 连续错误（包含没接到的球）次数
  clearNum: 0, // 95分以上的次数
  continuousNotClearTimes1: 0, // 连续未达到95分以上的次数
  continuousNotClearTimes2: 0, // 连续未达到60分以上的次数
  remindRollbackOne: false, // 需要提醒规则1
  remindRollbackTwo: false, // 需要提醒规则2
  waitForCheckingIfPass: false
}

const getters = {
  score (state) {
    if ((state.totalKeyHit) > 0) {
      return Math.round(state.correctTimes /
            (state.totalKeyHit + state.missedTimes) * 100)
    }
    return 0
  },
  clearNum (state) {
    return state.clearNum
  },
  stageOneClearNum (state) {
    return state.stageOneClearNum
  }
}

const mutations = {
  resetState (state) {
    state.lesson = null
    state.started = true
    state.numOfDrops = null
    state.speed = null
    state.practiceMinutes = null
    state.configured = false
    state.mode = null
    state.correctTimes = 0
    state.incorrectTimes = 0
    state.missedTimes = 0
    state.missedBalls = []
    state.timeElapsed = 0
    state.totalKeyHit = 0
  },
  incrementTimer (state) {
    (state.timeElapsed) += TIMER_STEP
  },
  setTimer (state, payload) {
    state.timer = payload.timer
  },
  // start (state, payload) {
  //   state.lesson = payload.lesson
  //   state.started = true
  //   state.numOfDrops = null
  //   state.speed = null
  //   state.practiceMinutes = null
  //   state.configured = false
  //   state.mode = payload.mode
  //   state.correctTimes = 0
  //   state.missedBalls = []
  //   state.timeElapsed = 0
  //   state.totalKeyHit = 0
  // },
  configure (state, payload) {
    state.configured = true
    state.numOfDrops = payload.numOfDrops
    state.speed = payload.speed
    state.practiceMinutes = payload.practiceMinutes
    state.totalKeyHit = 0
    state.missedBalls = []
    state.missedTimes = 0
    state.correctTimes = 0
    state.incorrectTimes = 0
    state.continuousCorrectTimes = 0
    state.continuousInorrectTimes = 0
    state.timeElapsed = 0
    state.remindRollbackOne = false
    state.remindRollbackTwo = false
  },
  hitKey (state) {
    state.totalKeyHit += 1
  },
  correct (state) {
    state.correctTimes += 1
    state.continuousCorrectTimes += 1
    state.continuousInorrectTimes = 0
    if (state.continuousCorrectTimes === 10) {
      if (state.speed === 1) {
        state.speed = 2
      } else if (state.speed === 2 && state.numOfDrops === 1) {
        state.speed = 3
      } else if (state.speed === 3 && state.numOfDrops === 1) {
        state.speed = 2
        state.numOfDrops = 2
      } else if (state.speed === 2 && state.numOfDrops === 2) {
        state.numOfDrops = 3
      }
      state.continuousCorrectTimes = 0
    }
  },
  wrong (state, payload) {
    state.incorrectTimes += 1
    state.continuousCorrectTimes = 0
    state.continuousInorrectTimes += 1
    if (state.continuousInorrectTimes === 2) {
      if (state.speed === 2 && state.numOfDrops === 3) {
        state.numOfDrops = 2
      } else if (state.speed === 2 && state.numOfDrops === 2) {
        state.speed = 3
        state.numOfDrops = 1
      } else if (state.speed === 3 && state.numOfDrops === 1) {
        state.speed = 2
      } else if (state.speed === 2) {
        state.speed = 1
      }
      state.continuousInorrectTimes = 0
    }
    if (state.missedBalls.length < 10) {
      state.missedBalls.push(payload.ball)
    }
  },
  miss (state) {
    state.missedTimes += 1
    state.incorrectTimes -= 1
  },
  end (state, payload) {
    const currentLesson = payload.currentLesson
    const score = payload.score
    if (score < currentLesson.threshold_rollback_score_two) { // < 60
      state.continuousNotClearTimes1 += 1
      state.continuousNotClearTimes2 += 1
    } else if (score < currentLesson.threshold_rollback_score_one) { // < 95
      state.continuousNotClearTimes1 += 1
      state.continuousNotClearTimes2 = 0
    } else {
      state.continuousNotClearTimes1 = 0
      state.continuousNotClearTimes2 = 0
    }
    if (state.continuousNotClearTimes2 >= currentLesson.threshold_rollback_frequency_two) {
      state.remindRollbackTwo = true
      state.remindRollbackOne = false
    } else if (state.continuousNotClearTimes >= currentLesson.threshold_rollback_frequency_one) {
      state.remindRollbackOne = true
      state.remindRollbackTwo = false
    } else {
      state.remindRollbackOne = false
      state.remindRollbackTwo = false
    }
    state.timer.clear()
    state.timer = null
  },
  clearMissedBallFromFront (state, payload) {
    state.missedBalls[payload.index] = undefined
    state.missedBalls = [...state.missedBalls]
  },
  checkIfPass (state, clearNum) {
    state.clearNum = clearNum
  },
  setWaitForCheckingIfPass (state, status) {
    state.waitForCheckingIfPass = status
  }
}

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
  startTimer (context) {
    if (context.state.timer && context.state.timer.clear) {
      return
    }
    const timer = accurateInterval(
      () => context.commit('incrementTimer'),
      TIMER_STEP,
      { aligned: true }
    )
    context.commit('setTimer', { timer })
  },
  stopTimer (context) {
    if (context.state.timer && context.state.timer.clear) {
      context.state.timer.clear()
    }
    context.commit('setTimer', { timer: null })
  },
  // start (context, params) {
  //   context.commit('start', { lesson: params.lesson, mode: params.mode })
  // },
  async configure (context, params) {
    await context.dispatch('startTimer')
    context.commit('configure', {
      numOfDrops: params.numOfDrops,
      speed: params.speed,
      practiceMinutes: params.practiceMinutes })
  },
  hitKey (context) {
    context.commit('hitKey')
  },
  correct (context) {
    context.commit('correct')
  },
  wrong ({ commit }, payload) {
    commit('wrong', payload)
  },
  miss ({ commit }, payload) {
    commit('miss')
    commit('wrong', payload)
  },
  async end ({ commit, state, getters }, payload) {
    let targetAPI = ''
    if (payload.category === 'single') {
      targetAPI = submitTypingSingleAdvancedRecordAPI
    } else if (payload.category === 'combine') {
      targetAPI = submitTypingCombineAdvancedRecordAPI
    }
    commit('end', { currentLesson: payload.currentLesson, score: getters.score })

    await axios.post(targetAPI, {
      lesson_id: payload.currentLesson.lesson_id,
      hit: state.totalKeyHit,
      correct: state.correctTimes,
      incorrect: state.incorrectTimes,
      miss: state.missedTimes,
      score: payload.notComplete ? 0 : getters.score,
      complete_used_time: state.timeElapsed / 1000,
      incorrect_miss_records: state.missedBalls.length > 0 ? state.missedBalls.map((each) => each.character).join('') : 'no_incorrect_miss_records'
    }).then((response) => {
      if (localStorage.practicedToday === 'false') {
        axios.post(firstPracticedAPI, {
          email: localStorage.email
        }).then(() => {
          localStorage.practicedToday = true
        })
      }
    }).catch((error) => {
      console.log('error:', error)
    })
  },
  clearMissedBallFromFront ({ commit }, payload) {
    commit('clearMissedBallFromFront', payload)
  },
  checkIfPass ({ commit }, payload) {
    let targetAPI = ''
    if (payload.category === 'single') {
      targetAPI = checkIfPassTypingSingleAdvancedLesson
    } else if (payload.category === 'combine') {
      targetAPI = checkIfPassTypingCombineAdvancedLesson
    }
    commit('setWaitForCheckingIfPass', true)
    axios.post(targetAPI, {
      lesson_id: payload.lesson_id,
      threshold_score: payload.threshold_score
    }).then((response) => {
      commit('checkIfPass', response.data)
      commit('setWaitForCheckingIfPass', false)
    }).catch((error) => {
      console.log('error:', error)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
